import { SxProps, Theme } from '@mui/material/styles';

export const PostUIStyles = {
  card: {
    backgroundColor: '#FFF8F5',
    width: '100%',
    maxWidth: 'min(400px, 90vw)',
    margin: '0 auto',
    borderRadius: '10px',
    border: '1px solid #000000 rgba(0, 0, 0, 0.4)',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.4)',
    // Force consistent width regardless of parent container
    minWidth: 'min(300px, 85vw)',
  },

  cardContent: {
    alignItems: 'center',
    gap: 1
  },

  avatarContainer: {
    position: 'relative',
    '&::before': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      m: '-2px',
    },
  },

  avatar: {
    backgroundColor: '#FFE0B2',
    color: '#F57C00'
  },

  displayName: {
    fontWeight: 'lg',
    maxWidth: '150px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '@media (max-width: 600px)': {
      maxWidth: '120px',
    },
    '@media (max-width: 400px)': {
      maxWidth: '100px',
    }
  },

  actionButtonsContainer: {
    ml: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
  },

  followButton: (isFollowing: boolean) => ({
    borderColor: '#CAC4D0',
    color: isFollowing ? '#4FC3F7' : '#F57C00',
  }),

  imageContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain' as const,
    userSelect: 'none' as const,
    WebkitUserSelect: 'none' as const,
    MozUserSelect: 'none' as const,
    msUserSelect: 'none' as const,
  },

  video: {
    width: '100%',
    height: '100%',
    objectFit: 'contain' as const,
    userSelect: 'none' as const,
    WebkitUserSelect: 'none' as const,
    MozUserSelect: 'none' as const,
    msUserSelect: 'none' as const,
    backgroundColor: '#000',
  },

  imageIndicators: {
    position: 'absolute',
    bottom: 8,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: 1,
    zIndex: 1,
  },

  imageIndicator: (isActive: boolean) => ({
    fontSize: 8,
    color: isActive ? 'primary.main' : 'rgba(255, 255, 255, 0.6)',
  }),

  title: {
    fontSize: 'sm',
    fontWeight: 'bold',
    color: '#1D1B20'
  },

  description: (isExpanded: boolean) => ({
    display: '-webkit-box',
    WebkitLineClamp: isExpanded ? 'unset' : 2,
    WebkitBoxOrient: 'vertical' as const,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#49454F'
  }),

  showMoreButton: {
    color: 'primary.main',
    fontSize: 'xs',
    cursor: 'pointer',
    mt: 0.5,
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  locationIcon: {
    fontSize: 'sm',
    color: '#4FC3F7'
  },

  locationText: {
    color: '#4FC3F7',
    fontSize: 'md',
    fontWeight: 'sm',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 320
  },

  placeIcon: {
    fontSize: 'sm',
    color: '#4FC3F7'
  },

  placeText: {
    color: '#4FC3F7',
    fontSize: 'md',
    fontWeight: 'sm'
  },

  timeAgo: {
    fontSize: 'xs',
    fontWeight: 'sm'
  },

  bottomCardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 2,
    py: 1,
    width: '100%',
    maxWidth: 'min(400px, 90vw)',
    margin: '0 auto',
    minWidth: 'min(300px, 85vw)',
  },

  actionButtonsBox: {
    display: "flex",
    alignItems: "center",
    gap: 0.5
  },

  menuPaper: {
    maxHeight: 100,
  },

  favoriteIcon: {
    color: "red"
  },

  likeCount: {
    fontSize: "sm",
    ml: 0.5
  },
};